'use strict';

class HCBaseTheme {
  constructor() {
    let options = {
      chart: {
        height: 240,
        style: {
          fontFamily: '"Helvetica", "Arial", sans-serif'
        }
      },
      credits: {
        enabled: false
      },
      exporting: {
        enabled: false
      },
      title: {
        text: ''
      },
      plotOptions: {
        series: {
          pointPadding: 0,
          groupPadding: 0
        }
      },
      xAxis: {
        allowDecimals: false,
        tickLength: 0,
        title: null,
        labels: {
          groupedOptions: [{
            style: {
              color: '#222222',
              fontSize: '12px',
              fontWeight: 200
            }
          }],
          style: {
            color: '#222222',
            fontSize: '12px',
            fontWeight: 200
          }
        }
      },
      yAxis: {
        allowDecimals: false,
        endOnTick: true,
        title: null,
        gridLineColor: '#F3F3F3',
        showFirstLabel: false,
        tickPixelInterval: 50,
        labels: {
          style: {
            color: '#222222',
            fontSize: '12px',
            fontWeight: 200
          }
        }
      },
      tooltip: {
        shared: false,
        backgroundColor: '#BBBBBB',
        borderRadius: 12,
        borderWidth: 0,
        shadow: false,
        useHTML: true,
        style: {
          color: '#FFFFFF'
        }
      },
      legend: {
        enabled: false
      }
    };

    Highcharts.setOptions(options);
  }

  drawChart(container, options, callback) {
    $(() => { // Prevents errors with undefined $(container).highcharts
      $(container).highcharts(options, callback);
      this.chart = $(container).highcharts();
    })
  }

  setAdditionalOptions(options) {
    $.extend(true, this.options, options);
    return this;
  }

  // Definitions for formatters that are/might be reused
  static simpleFormattedNumberTooltip() {
    return `<p>${accounting.formatNumber(this.y)}</p>`;
  }

  static groupedColumnsTooltip() {
    const leftTranslations = this.series.chart.series[0].options.translations;
    const rightTranslations = this.series.chart.series[1].options.translations;

    const leftValue = this.series.chart.series[0].points[this.point.index].y;
    const rightValue = this.series.chart.series[1].points[this.point.index].y;

    const leftLabel = Stats.pluralize(leftTranslations[0], leftTranslations[1], leftValue)
    const rightLabel = Stats.pluralize(rightTranslations[0], rightTranslations[1], rightValue);

    const gap = accounting.formatNumber((rightValue / leftValue) * 100, 2);

    return `<p>${leftValue} <span style="font-weight: normal;">${leftLabel}</span></p>
            <p>${rightValue} <span style="font-weight: normal;">${rightLabel}</span></p>
            <p>${gap}%</p>`;
  }
}

export default HCBaseTheme;
